module.exports = __webpack_public_path__ + "media/images/dashboard/clubpilates-banner-bg-066b756876a4a9b539b070dd8c94bf94.jpg";